import React, { useState } from "react";
import {
  Modal,
  Spin,
  Layout,
  Breadcrumb,
  Alert,
  Select,
  Input,
  Space,
  Button,
} from "antd";
import {
  YEAR,
  BRAND,
  SETNAME,
  SUBSET,
  CARDNAME,
  CARDNUMBER,
  SERIALNUMBER,
  CARDNUMBER_FIRST_TYPES,
  CardKeys,
  CardKeys_Alt,
  CardLabels,
} from "./ProcessSets";
import "./index.css";

const { Option } = Select;
const { Content, Footer } = Layout;

const SelectCardFromDB = (props) => {
  const [showError, setShowError] = useState("");
  const validateAndDoNext = (e) => {
    switch (props.step) {
      case 1:
        if (props.selectedType) {
          props.nextCardStep();
        } else {
          setShowError("Please select card's sport type.");
        }
        break;
      case 2:
        if (
          props.selectedSet &&
          props.selectedSet.year &&
          props.selectedSet.brand &&
          props.selectedSet.set_name &&
          props.selectedSet.subset
        ) {
          props.nextCardStep();
        } else {
          //console.log(props.selectedSet);
          setShowError("Please select all set values.");
        }
        break;
      case 3:
        if (
          props.selectedCard &&
          props.selectedCard.card_name &&
          props.selectedCard.card_number
        ) {
          props.nextCardStep();
        } else {
          //console.log(props.selectedCard);
          setShowError("Please select all card values.");
        }
        break;
      default:
        break;
    }
  };
  const handleTypeChange = (value) => {
    setShowError("");
    props.updateType(value);
  };
  const handleSetChange = (value, key) => {
    setShowError("");
    props.updateSet(key, value);
  };
  const handleCardChange = (value, key) => {
    setShowError("");
    props.updateCard(key, value);
  };

  const getSelect = (value, data, callback, width = 200) => (
    <Select
      value={value}
      aria-required
      onSelect={callback}
      showSearch
      style={{ width: width }}
      optionFilterProp="children"
      listHeight={200}
      // open={true}
      // filterOption={(input, option) =>
      //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      // }
      // filterSort={(optionA, optionB) =>
      //   optionA.children
      //     .toLowerCase()
      //     .localeCompare(optionB.children.toLowerCase())
      // }
    >
      {data?.map((d, i) => (
        <Option key={i} value={d}>
          {d}
        </Option>
      ))}
    </Select>
  );

  const getCardHeader = () => {
    let cardKeys =
      CARDNUMBER_FIRST_TYPES.indexOf(props.selectedType) >= 0
        ? CardKeys_Alt
        : CardKeys;
    return cardKeys.map((c, i) => <th key={i}>{CardLabels[c]}</th>);
  };

  const getCardInputFields = () => {
    let cardKeys =
      CARDNUMBER_FIRST_TYPES.indexOf(props.selectedType) >= 0
        ? CardKeys_Alt
        : CardKeys;
    const getData = (key) => {
      switch (key) {
        case CARDNUMBER:
          return props.cardnumbers;
        case CARDNAME:
          return props.cardnames;
        default:
          return [];
      }
    };

    return cardKeys.map((c, i) => (
      <td key={i}>
        {c !== SERIALNUMBER &&
          getSelect(
            props.selectedCard[c],
            getData(c),
            (value) => handleCardChange(value, c),
            c === CARDNAME ? 500 : 200
          )}
        {c === SERIALNUMBER && (
          <Space direction="vertical">
            <Input
              value={props.selectedCard?.serial_number}
              onChange={(e) => handleCardChange(e.target.value, SERIALNUMBER)}
              addonAfter={props.displaySerial && `/${props.displaySerial}`}
              placeholder="Serial Number"
            />
          </Space>
        )}
      </td>
    ));
  };

  return (
    <>
      <Modal
        title="Select Card from Our Database"
        centered
        visible={props.visible}
        onOk={validateAndDoNext}
        onCancel={() => props.toggleWizard()}
        width={1200}
        confirmLoading={props.loading}
        // okText={props.step === 3 ? "Confirm" : "Next"}
        footer={[
          <Button key="cancel" onClick={() => props.toggleWizard()}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={props.loading}
            onClick={validateAndDoNext}
          >
            {props.step === 3 ? "Confirm" : "Next"}
          </Button>,
          <Button
            key="back"
            type="dashed"
            onClick={() => {
              props.previousCardStep();
            }}
            style={{ float: "left" }}
            disabled={props.step < 2}
          >
            Back
          </Button>,
          <Button
            key="notfound"
            type="secondary"
            loading={props.loading}
            onClick={() => props.toggleWizard(true)}
            style={{ float: "left" }}
          >
            Not Found? Add Manually..
          </Button>,
        ]}
      >
        <Layout className="site-layout">
          {props.step > 1 && (
            <Breadcrumb style={{ padding: 20 }}>
              <Breadcrumb.Item>{props.selectedType}</Breadcrumb.Item>
              {props.step > 2 && (
                <Breadcrumb.Item href="">
                  {props.selectedSet.year} - {props.selectedSet.brand} -{" "}
                  {props.selectedSet.set_name} - {props.selectedSet.subset}
                </Breadcrumb.Item>
              )}
            </Breadcrumb>
          )}
          <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
            <div
              className="site-layout-background"
              style={{ padding: 24, textAlign: "center" }}
            >
              {props.loading && <Spin tip="Loading..."></Spin>}
              {!props.loading && (
                <>
                  {showError && (
                    <Alert
                      message={showError}
                      type="error"
                      showIcon
                      style={{ marginBottom: 10 }}
                    />
                  )}
                  {props.step === 1 && (
                    <>
                      <label>Select Type: </label>
                      <div>
                        {getSelect(
                          props.selectedType,
                          props.types,
                          handleTypeChange
                        )}
                      </div>
                    </>
                  )}
                  {props.step === 2 && (
                    <>
                      <table>
                        <thead>
                          <tr>
                            <th>Year</th>
                            <th>Company</th>
                            <th>Set</th>
                            <th>Subset</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {getSelect(
                                props.selectedSet?.year,
                                props.years,
                                (value) => handleSetChange(value, YEAR),
                                150
                              )}
                            </td>
                            <td>
                              {getSelect(
                                props.selectedSet?.brand,
                                props.brands,
                                (value) => handleSetChange(value, BRAND),
                                200
                              )}
                            </td>
                            <td>
                              {getSelect(
                                props.selectedSet?.set_name,
                                props.setnames,
                                (value) => handleSetChange(value, SETNAME),
                                200
                              )}
                            </td>
                            <td>
                              {getSelect(
                                props.selectedSet?.subset,
                                props.subsets,
                                (value) => handleSetChange(value, SUBSET),
                                400
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                  {props.step === 3 && (
                    <table style={{ margin: "0 auto" }}>
                      <thead>
                        <tr>{getCardHeader()}</tr>
                      </thead>
                      <tbody>
                        <tr>{getCardInputFields()}</tr>
                      </tbody>
                    </table>
                  )}
                  {props.step === 4 && (
                    <p>select card and enter serial number</p>
                  )}
                </>
              )}
            </div>
          </Content>
          {props.step > 1 && (
            <Footer style={{ padding: 20, fontWeight: "bold" }}>
              Select "-" for "Not Applicable"
            </Footer>
          )}
        </Layout>
      </Modal>
    </>
  );
};

export default SelectCardFromDB;
